import { LOCAL_STORAGE } from "../components/utils/constants";

export const isIRNCodeEnable = () => {
    const enableClients = [1568];
    return enableClients.includes(Number(LOCAL_STORAGE.customerNo));
};

export const EnableIntegratedReferenceNo = () => {
    const enableClients = [1166, 1165, 1158];
    return enableClients.includes(Number(LOCAL_STORAGE.customerNo));
};
